export default __webpack_public_path__ + "static/media/waitingList.c5696a58.png";